import React from 'react';
import { Grid, Table, Modal, Button, Input, Dimmer, Loader, Segment } from 'semantic-ui-react';
import * as api from '../../api';
import { NoData } from "../../components/table/no-data";
import Field from "../../components/forms/field";
import { apiUrl } from "../../config.js";
import { FilePond } from 'react-filepond';
import { toast } from 'react-toastify';
import {
    DateInput
} from 'semantic-ui-calendar-react';
import { AuthService } from '../../services/auth-service';
import CreateCase from '../service-management/create-case';

const authService = new AuthService();


class UtilityMeterTableRow extends React.Component {

    constructor(props) {
        super(props);

        this.authServices = new AuthService();

        this.state = {
            utility: "",
            loadingread: true,
            readLoadError :false,
            address: "",
            serialnumber: "",
            ref: "",
            propertyname: "",
            lastreading: "",
            lastreadtype: "",
            datelastread: "",
            description: "",
            newReading: "",
            newDateRead: "",
            customerSiteKey: "",
            hasError: false,
            errorText: "",
            commitSuccess :false,
            isReadOnly : this.authServices.isReadOnly()
        }

    
    }

  
    componentDidMount = () => {
    };

    getMeterRead = (customerId, UtilityMeterKey) => {
       

        api.getMeterReadLookup(customerId, UtilityMeterKey)
            .then(meterDetail => {
                if (!meterDetail) { 
                    this.setState({
                        readLoadError : true,
                        hasError: true,
                        loadingread : false,
                        errorText: "Cannot retrieve Meter Details. Please close window and retry"
                    });
                    return; }
                var meterRead = meterDetail[0];
                if(!meterRead) { 
                    this.setState({
                        readLoadError : true,
                        hasError: true,
                        loadingread : false,
                        errorText: "Cannot retrieve Meter Information. Please close window and retry"
                    });
                    return; }

    
                    let address = "";
                    if (meterRead.addressDetails && meterRead.addressDetails.length > 0) {
                        const addressObj = meterRead.addressDetails[0];
                        address = addressObj.buildingNo || "";
                        address += addressObj.buildingName ? " " + addressObj.buildingName : "";
                        address += addressObj.subBuildingName ? " " + addressObj.subBuildingName : "";
                        address += addressObj.street ? ", " + addressObj.street : "";
                        address += addressObj.locality ? ", " + addressObj.locality : "";
                        address += addressObj.town ? ", " + addressObj.town : "";
                        address += addressObj.county ? ", " + addressObj.county : "";
                        address += addressObj.postcodeOut ? ", " + addressObj.postcodeOut : "";
                        address += addressObj.postcodeIn ? " " + addressObj.postcodeIn : "";
                        if (address.startsWith(", ")) {
                            address = address.replace(", ", "");
                          }
                    }


                this.setState({
                    loadingread: false,
                    address: address,
                    serialnumber: meterRead.serialNumber,
                    ref: meterRead.ref,
                    propertyname: meterRead.propertyName || meterRead.buildingName || meterRead.companySiteName || '',
                                        lastreading: meterRead.lastReading,
                    lastreadtype: meterRead.lastReadType,
                    datelastread: meterRead.dateLastRead,
                    description: meterRead.description,
                    customerSiteKey: meterRead.customerSiteKey,
                    utility: meterRead.utility
                });
                //this.setState({meterDetail: meterDetail, isLoaded: true});
            });

    }
    handleDateChange(name, value) {

        this.setState({
            [name]: value
        });

    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    submitMeterRead = () => {
      
        const formData = new FormData();


        if (this.state.newDateRead === "" && this.state.newReading === "") {
            this.setState({
                hasError: true,
                errorText: "Please ensure a new reading and date have been entered."
            });
            return;
        }


        formData.append("NewReading", this.state.newReading);
        formData.append("NewDateRead", this.state.newDateRead);
        formData.append("Description", this.state.description);
        formData.append("Utility", this.props.data.utility);

        formData.append("LastReading", this.state.lastreading);
        formData.append("LastDateRead", this.state.datelastread);

        try {
            api.MeterReadVerifySubmit(this.props.contextData.customerId, this.state.customerSiteKey, this.props.data.meterSiteKey, this.props.data.utilityMeterKey, formData)
                .then(verifyRes => {
                   

                    if (verifyRes.utilityMeterVerifyReadsRoot.utilityMeterVerifications[0].error !== "") {
                        this.setState({
                            hasError: true,
                            errorText: verifyRes.utilityMeterVerifyReadsRoot.utilityMeterVerifications[0].error
                        });
                    }else
                    {
                        this.setState({
                            commitSuccess: true
                        });

                    }

                }).catch(error => {
                   
                    this.setState({
                        hasError: true,
                        errorText: error
                    });
                });
        } catch (err) {
           
            this.setState({
                hasError: true,
                errorText: err
            });
        }



    };


    formatDate(dateStr) {
        if (!dateStr) return '';
        
        const date = new Date(dateStr);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        
        return `${day}/${month}/${year}`;
    }
    
    
                           
    render() {
        
        return (
            <Table.Row>

                <Table.Cell>{this.props.data.utility || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.serialNumber || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.supplierRef || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.amr || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.meterType || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.meterStatus || <NoData />}</Table.Cell>
                <Table.Cell>
                {(((this.props.data.meterType!=='Half Hour Meter' && this.props.data.meterType!=='Half Hourly' && this.props.data.meterType!=='Code 5')|| this.props.data.amr==='yes') &&   this.state.isReadOnly === false )  &&
                    <Modal size="large" trigger={<Button basic onClick={() => this.getMeterRead(this.props.contextData.customerId, this.props.data.utilityMeterKey)} >Submit Read</Button>} centered={false} closeIcon>


                        <Modal.Header><h2>{this.props.data.meterSiteKey}</h2></Modal.Header>
                        <Modal.Content>
                            {this.state.commitSuccess ? 
                            <Segment>
                                <div className="ui success message">
                                    <div className="header">
                                        Your Meter Reads were successful logged.
                                    </div>
                                    <p>You may now close this window</p>
                                    </div>

                            </Segment> : 

                            <Segment>

                                <Dimmer active={this.state.loadingread}>
                                    <Loader>Loading</Loader>
                                </Dimmer>


                                <h4>Current Reading Data</h4>
                                <Grid.Column>
                                    <Field label={"Utility"} value={this.state.utility || <NoData />} />
                                    <Field label={"Serial"} value={this.state.serialnumber || <NoData />} />
                                    <Field label={"Reference"} value={this.state.ref || <NoData />} />
                                    <Field label={"Property"} value={this.state.propertyname || <NoData />} />
                                    <Field label={"Address"} value={this.state.address || <NoData />} />
                                    {this.state.lastreading === 0 && 
                                    <Field label={"Last Valid Reading"} value="No previous reading" /> }

                                    {this.state.lastreading !== 0 && 
                                    <Field label={"Last Valid Reading"} value={this.state.lastreading + (this.state.datelastread ? " (" + this.formatDate(this.state.datelastread) + ")" : "") || <NoData />} />
                                }

                                </Grid.Column>
                                <div className="ui divider"></div>
                                <h4>Submit New Meter Reading</h4>
                              
                              
                                <Segment inverted color='blue'>
                                            To submit your meter reads, please enter the details below. Use the upload file feature to send us a photograph of the latest meter reading.
                                </Segment>
                                <Grid.Row>
                                    <Grid.Column>
                                        <FilePond onupdatefiles={this.onFilesUpdated} allowMultiple={false} allowRevert={false} allowRemove={true} allowProcess={false}   acceptedFileTypes={[
                                                    'image/jpeg',
                                                    'image/png',
                                                   
                                                    'image/tiff' // .tif
                                                ]}
                                                server={{
                                            process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
                                                this.setState({ showInfoHide: true })
                                                const formData = new FormData();
                                                formData.append(fieldName, file, file.name);
                                                formData.append("client", authService.getUserData(AuthService.CUSTOMER_ID_KEY));
                                                formData.append("uploadedBy", authService.getUserData(AuthService.EMAIL_KEY));
                                                const request = new XMLHttpRequest();

                                                request.open('POST', `${apiUrl}/MeterReads/AddAttatchmentToMeter/${authService.getUserData(AuthService.CUSTOMER_ID_KEY)}/${this.props.data.utilityMeterKey}`);
                                                request.setRequestHeader(
                                                    'Authorization', `bearer ${localStorage.getItem("token")}`);

                                                request.upload.onprogress = (e) => {
                                                    progress(e.lengthComputable, e.loaded, e.total);

                                                };

                                                request.onload = (e) => {
                                                
                                                    var obj = JSON.parse(e.srcElement.response);


                                                    if (request.status >= 200 && request.status < 300) {

                                                        if (obj.hasErrors) {
                                                            this.setState({
                                                                showErrorHide: false,
                                                                uploadStatusList: obj.statusList,
                                                                statusFileId : obj.statusFileId
                                                            })

                                                            error("Failed")
                                                       

                                                        } else {
                                                            this.setState({
                                                                showSuccessHide: false,
                                                                uploadStatusList: obj.statusList,
                                                                statusFileId : obj.statusFileId
                                                            })
                                                            load("Success");
                                                 
                                                        }

                                                    }
                                                    else {

                                                        this.setState({
                                                            showErrorHide: false,
                                                            uploadStatusList: ["failed upload please check the file format."]
                                                        })
                                                        error('Failed upload please check the file format. Only image files in format PNG, JPEG, JPG and BMP are allowed.');

                                                        toast.error("Failed upload please check the file format. Only image files in format PNG, JPEG, JPG and BMP are allowed.",
                                                            {
                                                               position: toast.POSITION.TOP_CENTER,
                                                              autoClose: false,
                                                              closeOnClick: true
                                                           });
                                                    }
                                                };

                                                request.send(formData);

                                                return {

                                                    abort: () => {
                                                        request.abort();
                                                        abort();
                                                    }
                                                };
                                            }
                                        }} />
                                    </Grid.Column>
                                </Grid.Row>
                               


                                <Grid padded stackable columns='equal'>
                                {this.state.readLoadError === false &&  

                                    <Grid.Row>

                                        <Grid.Column>
                                            <Input id="newReading" fluid placeholder='Meter Reading' value={this.state.newReading} onChange={this.handleChange} />
                                        </Grid.Column>

                                        <Grid.Column>
                                            <DateInput fluid
                                                popupPosition="top center"
                                                dateFormat="DD/MM/YYYY"
                                                animation='none'
                                                name="newDateRead"
                                                value={this.state.newDateRead}
                                                onChange={(a, { name, value }) => this.handleDateChange(name, value)}
                                            />
                                        </Grid.Column>



                                        <Grid.Column>
                                            <Input id="description" placeholder='Supply Description' fluid value={this.state.description} onChange={this.handleChange} />
                                        </Grid.Column>
                                    </Grid.Row>
                                  }
                                    {this.state.hasError ?
                                        <Grid.Row>
                                            <div className="ui error message">

                                                <div className="header">
                                                    There were some errors with your submission
                                                 </div>
                                                <ul className="list">
                                                    <li>{this.state.errorText}</li>
                                                    <li>Please contact your account manager for further assistance or raise a case</li>
                                                </ul>
                                                {(this.authServices.hasCaseManActive(this.props.customerId)) &&
    

                                                <CreateCase assetLabel={"Failed meter read submission"} siteKey={this.state.customerSiteKey} meterSiteKey={this.props.data.meterSiteKey} utility={this.props.data.utility}
                                                
                                                supplementalInfo={
                                                    "Reading Submitted : " + this.state.newReading + " \n" +
                                                    "Date of Read : " + this.state.newDateRead + " \n" +
                                                    "Supply Description : " + this.state.description + " \n" +
                                                    "File uploaded to ICMAS: " + (this.state.statusFileId ? "Yes" : "No") 
                                            
                                                }
                                                ></CreateCase>
                                            }
                                                
                                            </div>
                                        </Grid.Row>

                                        : null}
                                </Grid>
                                <Grid verticalAlign='middle'>
 
                            </Grid>
                            </Segment>
                        }
                        </Modal.Content>
                        <Modal.Actions>
                        {this.state.commitSuccess !== true ? 
                            <Button compact onClick={a => this.submitMeterRead()} >Submit</Button>
                            : null }
                        </Modal.Actions>
                    </Modal>
                }
                </Table.Cell>
            </Table.Row>
        );
    }
}

export default UtilityMeterTableRow;